var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgOutlook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1407_29483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 7.8139C16.0008 7.68879 15.9362 7.57235 15.8295 7.50692H15.8277L15.821 7.5032L10.2768 4.22134C10.2529 4.20517 10.228 4.19038 10.2024 4.17707C9.98831 4.06663 9.73403 4.06663 9.51996 4.17707C9.49432 4.19039 9.46948 4.20517 9.44554 4.22134L3.90137 7.5032L3.89468 7.50692C3.72523 7.6123 3.67328 7.83509 3.77865 8.00453C3.8097 8.05446 3.85246 8.09606 3.90323 8.12571L9.44742 11.4076C9.47144 11.4236 9.49628 11.4384 9.52184 11.4519C9.7359 11.5623 9.99018 11.5623 10.2043 11.4519C10.2298 11.4384 10.2546 11.4236 10.2787 11.4076L15.8229 8.12571C15.9336 8.06114 16.0012 7.94211 16 7.8139Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54763 5.62269H8.18595V8.95776H4.54763V5.62269ZM15.2557 2.23256V0.706973C15.2645 0.325542 14.9625 0.00913994 14.5811 0H5.13964C4.75821 0.00913994 4.45629 0.325542 4.46503 0.706973V2.23256L10.0464 3.72092L15.2557 2.23256Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46533 2.23267H8.18626V5.5815H4.46533V2.23267Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.907 2.23267H8.18604V5.5815L11.907 8.93033H15.2558V5.5815L11.907 2.23267Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18604 5.5813H11.907V8.93013H8.18604V5.5813Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18604 8.93018H11.907V12.279H8.18604V8.93018Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54785 8.95776H8.18618V11.9896H4.54785V8.95776Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9067 8.93018H15.2556V12.279H11.9067V8.93018Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8293 8.10532L15.8223 8.10904L10.2781 11.2272C10.2539 11.2421 10.2294 11.2562 10.2037 11.2688C10.1095 11.3137 10.0072 11.339 9.90302 11.3433L9.60014 11.1661C9.57454 11.1533 9.54969 11.139 9.52572 11.1234L3.90712 7.91666H3.90452L3.7207 7.81396V14.1261C3.72357 14.5473 4.06719 14.8864 4.48833 14.8837H15.244C15.2504 14.8837 15.2559 14.8808 15.2626 14.8808C15.3516 14.8751 15.4393 14.8568 15.5231 14.8264C15.5593 14.8111 15.5943 14.7929 15.6277 14.7721C15.6526 14.758 15.6954 14.7271 15.6954 14.7271C15.886 14.586 15.9988 14.3633 15.9998 14.1262V7.81396C15.9996 7.9347 15.9345 8.04602 15.8293 8.10532Z",
    fill: "url(#paint0_linear_1407_29483)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.7021 7.78896V8.17594L9.90491 12.1674L3.90305 7.91919C3.90305 7.91714 3.90138 7.91547 3.89933 7.91547L3.34863 7.58431V7.30524L3.57561 7.30151L4.05561 7.57687L4.06676 7.58059L4.10769 7.60664C4.10769 7.60664 9.74862 10.8252 9.7635 10.8327L9.97932 10.9592C9.99792 10.9517 10.0165 10.9443 10.0388 10.9369C10.05 10.9294 15.6388 7.78523 15.6388 7.78523L15.7021 7.78896Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8293 8.10532L15.8223 8.1094L10.2781 11.2275C10.2539 11.2424 10.2293 11.2566 10.2037 11.2692C9.98835 11.3744 9.73655 11.3744 9.52124 11.2692C9.49574 11.2566 9.47091 11.2427 9.44682 11.2275L3.90265 8.1094L3.89596 8.10532C3.78892 8.04728 3.72181 7.93572 3.7207 7.81396V14.1261C3.72337 14.5472 4.06687 14.8864 4.48792 14.8837C4.48793 14.8837 4.48794 14.8837 4.48796 14.8837H15.2325C15.6536 14.8864 15.9971 14.5472 15.9998 14.1262C15.9998 14.1262 15.9998 14.1262 15.9998 14.1261V7.81396C15.9996 7.9347 15.9345 8.04602 15.8293 8.10532Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.359 11.1814L10.2761 11.2279C10.252 11.2432 10.2272 11.2573 10.2016 11.27C10.1102 11.3148 10.0108 11.3411 9.90918 11.3473L12.0186 13.8419L15.6982 14.7286C15.799 14.6524 15.8792 14.5522 15.9315 14.4372L10.359 11.1814Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M10.7349 10.97L10.2761 11.2278C10.252 11.2431 10.2272 11.2572 10.2016 11.2699C10.1102 11.3147 10.0108 11.3411 9.90918 11.3473L10.8975 14.0721L15.6993 14.7274C15.8885 14.5853 15.9998 14.3626 16 14.1261V14.0446L10.7349 10.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49838 14.8837H15.2314C15.3965 14.8846 15.5576 14.8324 15.6909 14.7349L9.59976 11.1669C9.57417 11.1541 9.54932 11.1398 9.52534 11.1241L3.90674 7.91741H3.90414L3.7207 7.81396V14.1046C3.72028 14.5345 4.06846 14.8833 4.49838 14.8837C4.49837 14.8837 4.49837 14.8837 4.49838 14.8837Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.93 3.65885V11.5956C8.92934 11.8739 8.76014 12.124 8.5021 12.2282C8.42216 12.2625 8.33607 12.2802 8.24907 12.2802H3.7207V3.3489H4.46489V2.97681H8.24908C8.62498 2.97823 8.92919 3.28294 8.93 3.65885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55791 4.03095V11.9677C8.55885 12.0576 8.53979 12.1465 8.5021 12.2281C8.39876 12.4829 8.15185 12.65 7.87698 12.6512H3.7207V3.34891H7.87698C7.98495 3.34782 8.09135 3.37476 8.18582 3.42705C8.41391 3.54197 8.55783 3.77555 8.55791 4.03095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55791 4.03095V11.2235C8.5561 11.5992 8.25271 11.9038 7.87699 11.907H3.7207V3.34891H7.87698C7.98495 3.34782 8.09135 3.37476 8.18582 3.42705C8.41391 3.54197 8.55783 3.77555 8.55791 4.03095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.18582 4.03092V11.2235C8.18541 11.5998 7.8812 11.9052 7.50489 11.907H3.7207V3.34888H7.50488C7.88116 3.34908 8.18602 3.65428 8.18581 4.03055C8.18582 4.03068 8.18582 4.0308 8.18582 4.03092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.682044 3.34888H7.50399C7.88068 3.34888 8.18604 3.65424 8.18604 4.03092V10.8529C8.18604 11.2296 7.88068 11.5349 7.50399 11.5349H0.682044C0.305358 11.5349 0 11.2295 0 10.8529V4.03092C0 3.65424 0.305366 3.34888 0.682044 3.34888Z",
    fill: "url(#paint1_linear_1407_29483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1317 6.20955C2.2998 5.8514 2.57113 5.55167 2.91087 5.3489C3.2871 5.1335 3.71547 5.02612 4.14882 5.03857C4.55046 5.02986 4.94678 5.13167 5.29449 5.33289C5.62142 5.52785 5.88472 5.81352 6.05244 6.15522C6.2351 6.53174 6.32613 6.94611 6.31812 7.36452C6.32697 7.80179 6.23331 8.23507 6.04463 8.62963C5.87291 8.98354 5.60126 9.27939 5.26324 9.48061C4.90212 9.68799 4.49109 9.79248 4.07477 9.78275C3.66455 9.79265 3.25949 9.68968 2.9038 9.48507C2.57404 9.28985 2.30744 9.00387 2.1358 8.66125C1.95205 8.29018 1.85994 7.88047 1.86715 7.46646C1.85949 7.03291 1.94993 6.60324 2.1317 6.20955ZM2.96221 8.23001C3.05184 8.45643 3.20382 8.65279 3.40053 8.79633C3.6009 8.93637 3.84081 9.00861 4.08518 9.00247C4.34542 9.01276 4.60195 8.93806 4.81597 8.78963C5.01019 8.64655 5.15819 8.44965 5.24164 8.22331C5.33494 7.97053 5.38098 7.70277 5.37746 7.43336C5.38034 7.16137 5.33706 6.89087 5.24946 6.63336C5.17208 6.40087 5.02886 6.19586 4.83718 6.04322C4.62852 5.88777 4.37269 5.80893 4.11271 5.81996C3.86305 5.8135 3.61776 5.88631 3.41207 6.02796C3.21203 6.17211 3.05716 6.37021 2.96556 6.59912C2.76235 7.12383 2.7613 7.70531 2.96258 8.23075L2.96221 8.23001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9067 2.23267H15.2556V5.5815H11.9067V2.23267Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1407_29483",
    x1: 9.86024,
    y1: 7.81397,
    x2: 9.86024,
    y2: 14.8837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1407_29483",
    x1: 1.42208,
    y1: 2.81594,
    x2: 6.76396,
    y2: 12.0679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1407_29483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14.8837,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgOutlook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outlook.09c4642b28e6117b7ef917244c9686ea.svg";